<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<style lang="sass" scoped>
@import 'component'
</style>

<template lang="pug">

  form(v-on:submit.prevent="onSubmit")

    c-form-error(v-bind:message="$t(responseErrorMessage)")

    div(v-bind:class="$v.country.$error ? 'is-invalid' :'is-dirty'")
      div.invalid-feedback(v-if="!$v.country.required") {{ $t('error_country_required') }}

    div(v-bind:class="$v.language.$error ? 'is-invalid' :'is-dirty'")
      div.invalid-feedback(v-if="!$v.language.required") {{ $t('error_language_required') }}

    div(v-bind:class="$v.phoneCode.$error ? 'is-invalid' :'is-dirty'")
      div.invalid-feedback(v-if="!$v.phoneCode.required") {{ $t('error_phone_code_required') }}
      div.invalid-feedback(v-else-if="!$v.phoneCode.numeric") {{ $t('error_phone_code_numeric') }}
      div.invalid-feedback(v-else-if="!$v.phoneCode.minLength") {{ $t('error_phone_code_min_length', { min: $v.password.$params.minLength.min }) }}

    div(v-bind:class="$v.phoneNumber.$error ? 'is-invalid' :'is-dirty'")
      div.invalid-feedback(v-if="!$v.phoneNumber.required") {{ $t('error_phone_number_required') }}
      div.invalid-feedback(v-else-if="!$v.phoneNumber.numeric") {{ $t('error_phone_number_numeric') }}
      div.invalid-feedback(v-else-if="!$v.phoneNumber.minLength") {{ $t('error_phone_number_min_length', { min: $v.password.$params.minLength.min }) }}

    .wrapper-sections
      .section.left-section
        //Name
        .form-group
          input(
            type="text",
            v-model="firstName"
            :disabled="isLoading"
            :placeholder="$t('label_name')"
            :class="$v.firstName.$error ? 'is-invalid' :'is-dirty'"
            @input="$v.firstName.$touch() && $v.clientType.$touch()"
          )
          .form-group-text
            div.invalid-feedback(v-if="!$v.firstName.required") {{ $t('error_first_name_required') }}

        //Surname
        .form-group
          input(
            type="text"
            v-model="lastName"
            :disabled="isLoading"
            :placeholder="$t('label_surname')"
            :class="$v.lastName.$error ? 'is-invalid' :'is-dirty'"
            @input="$v.lastName.$touch()"
          )
          .form-group-text
            div.invalid-feedback(v-if="!$v.lastName.required") {{ $t('error_last_name_required') }}

        //Email
        .form-group
          input(
            type="email"
            v-model="email"
            :disabled="isLoading"
            :placeholder="$t('label_email')"
            :class="$v.email.$error ? 'is-invalid' :'is-dirty'"
            @input="$v.email.$touch()"
          )
          .form-group-text
            label (будет выслан код подтверждения)
            div.invalid-feedback(v-if="!$v.email.required") {{ $t('error_email_required') }}
            div.invalid-feedback(v-if="!$v.email.email") {{ $t('error_email_not_valid') }}

        //INN
        .form-group(:class="$v.inn.$error ? 'is-invalid' :'is-dirty'" )
          c-input-inn(v-model="inn" v-bind:value="inn" @set-vat="setVat")
          .form-group-text
            label  Нужно выбрать компанию из выпадающего списка
            div.invalid-feedback(v-if="!$v.inn.required") {{ $t('error_inn_required') }}
            div.invalid-feedback(v-if="!$v.inn.isInnValid") {{ $t('error_inn_is_not_valid') }}
            <!--div.invalid-feedback(v-if="!$v.inn.isInnActive") {{ $t('error_inn_is_not_active') }}-->

        //VAT
        .form-group.group-input-vat(v-bind:class="$v.inn.$error ? 'is-invalid' :'is-dirty'" )
          vue-select(:value="vatData[vat]" :placeholder="'Вид налогообложения'" :clearable="false" :options="vatData" @input="setVat")
          .form-group-text
            label Выберите вид налогообложения
            div.form-group(v-if="showCompanyWarning" v-bind:class="$v.inn.$error ? 'is-invalid' :'is-dirty'" )
              c-form-warning(v-bind:message="'Вы будете зарегистрированы, но не сможете забирать грузы от имени этой компании, пока администратор компании не разрешит это'")

        .form-group.group-input-vat-percentages(v-if="vatData[vat] === 'С НДС'")
          vue-select(:value="selectedPercentage" :placeholder="'Выберите процентную ставку'" :clearable="false" :options="vatPercentages" @input="setPercentage")
          .form-group-text
            label Выберите процентную ставку

      .section.right-section
        // Password
        div(:class="$v.password.$error ? 'is-invalid' :'is-dirty'")
          .form-group.input-password
            input(
              type="password"
              v-model="password"
              autocomplete="new-password"
              :disabled="isLoading"
              :placeholder="$t('label_password')"
              :class="checkNotSamePass() ? 'is-invalid' :'is-dirty'"
              @input="$v.password.$touch()"
            )
            .form-group-text
              label
                // Больше XX знаков, включая буквы и цифры
          .form-group.input-password
            input(
              type="password"
              v-model="repeatPassword"
              autocomplete="new-password"
              :disabled="isLoading"
              :placeholder="$t('label_repeat_password')"
              :class="$v.password.$error && checkNotSamePass() ? 'is-invalid' :'is-dirty'"
            )
            .form-group-text
              div.invalid-feedback(v-if="!$v.password.required") {{ $t('error_password_required') }}
              div.invalid-feedback(v-else-if="checkNotSamePass()") {{ $t('error_password_not_same') }}
              div.invalid-feedback(v-else-if="!$v.password.minLength") {{ $t('error_password_min_length', { min: $v.password.$params.minLength.min }) }}

    .section-address-switch
      .form-group.input-radio-wrapper
        .input-radio
          label(:class="{'label-checked': !additionalPostAddress}")
            input.custom-radio(
              type="radio"
              name="address-switch"
              value="false"

              @change="setShowAddress(false)"
              :checked="additionalPostAddress === false"
            )
          span Почтовый адрес совпадает с юридическим
        .input-radio
          label(:class="{'label-checked': additionalPostAddress}")
            input.custom-radio(
              type="radio"
              name="address-switch"
              value="true"

              @change="setShowAddress(true)"
              :checked="additionalPostAddress === true"
            )
          span Почтовый адрес не совпадает с юридическим

    .section-address(v-if="additionalPostAddress")
      label.text-center {{ $t('real_post_address') }}

      .inputs
        .inputs-section.inputs-left-section
          .form-group
            input(
              v-model="realPostAddressIndex"
              type="text"
              :disabled="isLoading"
              :placeholder="$t('real_post_address_index')"
              :class="$v.realPostAddressIndex.$error ? 'is-invalid' :'is-dirty'"
              @input="$v.realPostAddressIndex.$touch()"
            )
            .form-group-text
              div.invalid-feedback(v-if="!$v.realPostAddressIndex.required")
                span {{ $t('error_real_post_address_index_required') }}
          .form-group
            input(
              v-model="realPostAddressCity"
              type="text"
              :disabled="isLoading"
              :placeholder="$t('real_post_address_city')"
              :class="$v.realPostAddressCity.$error ? 'is-invalid' :'is-dirty'"
              @input="$v.realPostAddressCity.$touch()"
            )
            .form-group-text
              div.invalid-feedback(v-if="!$v.realPostAddressCity.required")
                span {{ $t('error_real_post_address_city_required') }}
          .form-group
            input(
              v-model="realPostAddressStreet"
              type="text"
              :disabled="isLoading"
              :placeholder="$t('real_post_address_street')"
              :class="$v.realPostAddressStreet.$error ? 'is-invalid' :'is-dirty'"
              @input="$v.realPostAddressStreet.$touch()"
            )
            .form-group-text
              div.invalid-feedback(v-if="!$v.realPostAddressStreet.required")
                span {{ $t('error_real_post_address_street_required') }}

        .inputs-section.inputs-right-section
          .form-group
            input(
              v-model="realPostAddressHouse"
              type="text"
              :disabled="isLoading"
              :placeholder="$t('real_post_address_house')"
              :class="$v.realPostAddressHouse.$error ? 'is-invalid' :'is-dirty'"
              @input="$v.realPostAddressHouse.$touch()"
            )
            .form-group-text
              div.invalid-feedback(v-if="!$v.realPostAddressHouse.required")
                span {{ $t('error_real_post_address_house_required') }}
          .form-group
            input(
              v-model="realPostAddressBuilding"
              type="text"
              :disabled="isLoading"
              :placeholder="$t('real_post_address_building')"
            )
            .form-group-text
          .form-group
            input(
              v-model="realPostAddressOffice"
              type="text"
              :disabled="isLoading"
              :placeholder="$t('real_post_address_office')"
            )
            .form-group-text
    .info-text Нажимая кнопку "зарегистрироваться" пользователь подтверждает принятие условий документов, размещенных по ссылкам ниже.
    .form-group.input-checkbox(:class="{'not-checked': notCheckerContract}")
      input.custom-checkbox(
        type="checkbox"
        id="user-agreement"
        @change="termsOfUse = $event.target.checked"
      )
      label(for="user-agreement")
      span
        | Пользователь соглашается с условиями
        a(href="https://static.deliver.ru/documents/icd_contract_electron.pdf" target="_blank") рамочного договора
        | об организации перевозок и о транспортно-экспедиционном обслуживании Deliver
    .form-group.input-checkbox(:class="{'not-checked': notCheckedSignatureContract}")
      input.custom-checkbox(
        type="checkbox"
        id="signature-contract"
        @change="signatureContract = $event.target.checked"
      )
      label(for="signature-contract")
      span
        a(href="https://static.deliver.ru/documents/Analogue_of_own_signature.pdf" target="_blank")
          | Согласен с порядком подписания документов в электронном виде
    div
      c-form-submit(
        :isLoading="requestBeingProcessed"
        :isDisabled="!termsOfUse"
      ) {{ $t('btn_sign_in') }}

</template>

<script>
import VueSelect from 'vue-select';
import { email, minLength, numeric, required, requiredIf, sameAs } from 'vuelidate/lib/validators';

import * as errorCodes from 'classes/error-codes';
import * as responseCodes from 'classes/response-codes';
import cFormError from 'components/c-form/c-form-error/component';
import cInputInn from 'components/c-form/c-form-inn/component';
import cFormSubmit from 'components/c-form/c-form-submit/component';
import cFormWarning from 'components/c-form/c-form-warning/component';
import mFormSubmit from 'mixins/formSubmit';
import mMask from 'mixins/mask';
import * as types from 'store/mutation-types';

export default {
  name: 'RegistrationFormComponent',
  mixins: [mMask, mFormSubmit],
  components: {
    cFormError,
    cFormWarning,
    cFormSubmit,
    cInputInn,
    VueSelect,
  },
  data() {
    return {
      showCompanyWarning: false,
      isLoading: false,
      termsOfUse: false,
      signatureContract: false,
      showPostAddress: false,
      vatData: ['Без НДС', 'С НДС'],
      vatPercentages: ['22%', '7%', '5%', '0%'],
      selectedPercentage: '22%',
      notCheckerContract: false,
      notCheckedSignatureContract: false,
    };
  },

  computed: {
    country: {
      get() {
        return this.$store.state.configuration.country;
      },
      set(value) {
        this.$store.commit(`configuration/${types.SET_COUNTRY}`, value);
      },
    },
    language: {
      get() {
        return this.$store.state.configuration.language;
      },
      set(value) {
        this.$store.commit(`configuration/${types.SET_LANGUAGE}`, value);
      },
    },
    phoneCode: {
      get() {
        return this.$store.state.registration.phoneCode;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_PHONE_CODE}`, value);
      },
    },
    phoneNumber: {
      get() {
        return this.$store.state.registration.phoneNumber;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_PHONE_NUMBER}`, value);
      },
    },
    inn: {
      get() {
        return this.$store.state.registration.inn;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_INN}`, value);
      },
    },
    vat: {
      get() {
        return this.$store.state.registration.vat;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_VAT}`, value);
      },
    },
    clientType: {
      get() {
        return this.$store.state.registration.clientType;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_CLIENT_TYPE}`, value);
      },
    },
    firstName: {
      get() {
        const value = this.$store.state.registration.firstName;

        return typeof value === 'string' ? value.trim() : value;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_FIRST_NAME}`, value.trim());
      },
    },
    lastName: {
      get() {
        const value = this.$store.state.registration.lastName;

        return typeof value === 'string' ? value.trim() : value;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_LAST_NAME}`, value.trim());
      },
    },
    // postAddress: {
    //   get() {
    //     let value = this.$store.state.registration.postAddress;

    //     return typeof value === 'string' ? value.trim() : value;

    //   },
    //   set(value) {
    //     this.$store.commit('registration/' + types.SET_POST_ADDRESS, value.trim())
    //   }
    // },
    additionalPostAddress: {
      get() {
        return this.$store.state.registration.additionalPostAddress;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_ADDITIONAL_POST_ADDRESS}`, value);
      },
    },
    realPostAddressIndex: {
      get() {
        const value = this.$store.state.registration.realPostAddressIndex;

        return typeof value === 'string' ? value.trim() : value;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_REAL_POST_ADDRESS_INDEX}`, value.trim());
      },
    },
    realPostAddressCity: {
      get() {
        const value = this.$store.state.registration.realPostAddressCity;

        return typeof value === 'string' ? value.trim() : value;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_REAL_POST_ADDRESS_CITY}`, value.trim());
      },
    },
    realPostAddressStreet: {
      get() {
        const value = this.$store.state.registration.realPostAddressStreet;

        return typeof value === 'string' ? value.trim() : value;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_REAL_POST_ADDRESS_STREET}`, value.trim());
      },
    },
    realPostAddressHouse: {
      get() {
        const value = this.$store.state.registration.realPostAddressHouse;

        return typeof value === 'string' ? value.trim() : value;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_REAL_POST_ADDRESS_HOUSE}`, value.trim());
      },
    },
    realPostAddressBuilding: {
      get() {
        const value = this.$store.state.registration.realPostAddressBuilding;

        return typeof value === 'string' ? value.trim() : value;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_REAL_POST_ADDRESS_BUILDING}`, value.trim());
      },
    },
    realPostAddressOffice: {
      get() {
        const value = this.$store.state.registration.realPostAddressOffice;

        return typeof value === 'string' ? value.trim() : value;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_REAL_POST_ADDRESS_OFFICE}`, value.trim());
      },
    },
    email: {
      get() {
        return this.$store.state.registration.email;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_EMAIL}`, value);
      },
    },
    password: {
      get() {
        return this.$store.state.registration.password;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_PASSWORD}`, value);
      },
    },
    repeatPassword: {
      get() {
        return this.$store.state.registration.repeatPassword;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_REPEAT_PASSWORD}`, value);
      },
    },
    returnUrl: {
      get() {
        return this.$store.state.registration.returnUrl;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_RETURN_URL}`, value);
      },
    },
    cookie: {
      get() {
        return this.$store.state.registration.cookie;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_COOKIE}`, value);
      },
    },
    emailCode() {
      return this.$store.state.registration.emailCode;
    },
    emailCodeValid() {
      return this.$store.state.registration.emailCodeValid;
    },
    smsCode() {
      return this.$store.state.registration.smsCode;
    },
    smsCodeValid() {
      return this.$store.state.registration.smsCodeValid;
    },
  },

  validations: {
    country: {
      required,
    },
    language: {
      required,
    },
    phoneCode: {
      required,
      numeric,
      minLength: minLength(1),
    },
    phoneNumber: {
      required,
      numeric,
      minLength: minLength(10),
    },
    clientType: {
      required,
    },
    inn: {
      required: requiredIf((nestedModel) => nestedModel.clientType === 'client'),
      isInnValid(value) {
        if (value === '') {
          return true;
        }
        if (value === null) {
          return true;
        }
        return value.length === 10 || value.length === 12;
      },
    },
    firstName: {
      required,
    },
    lastName: {
      required,
    },
    // postAddress: {
    //   required: requiredIf( function() { return this.showPostAddress; })
    // },
    realPostAddressIndex: {
      required: requiredIf(function () {
        return this.additionalPostAddress;
      }),
    },
    realPostAddressCity: {
      required: requiredIf(function () {
        return this.additionalPostAddress;
      }),
    },
    realPostAddressStreet: {
      required: requiredIf(function () {
        return this.additionalPostAddress;
      }),
    },
    realPostAddressHouse: {
      required: requiredIf(function () {
        return this.additionalPostAddress;
      }),
    },
    email: {
      email,
      required,
    },
    password: {
      required,
      minLength: minLength(4),
      sameAsPassword: sameAs('repeatPassword'),
    },
  },

  mounted() {
    if (this.smsCodeValid !== true) {
      this.$router.push({ name: 'enter-number' });
    }

    if (this.$route.params.action === 'submit') {
      this.handleSubmit();
    } else {
      this.handleInn();
      this.$store.commit(`registration/${types.SET_EMAIL_CODE}`, null);
      this.$store.commit(`registration/${types.SET_EMAIL_CODE_VALID}`, false);
    }
  },

  watch: {
    inn(value) {
      this.handleInn();
    },

    clientType(value) {
      if (value === 'driver') {
        this.handleInn();
      }
    },
    termsOfUse(val) {
      if (val) {
        this.notCheckerContract = false;
      }
    },
    signatureContract(val) {
      if (val) {
        this.notCheckedSignatureContract = false;
      }
    },
  },

  methods: {
    checkNotSamePass() {
      if (!this.repeatPassword) {
        return false;
      }

      return !this.$v.password.sameAsPassword;
    },
    onSubmit() {
      if (!this.termsOfUse) {
        this.setResponseError('Необходимо согласиться с условиями рамочного договора');
        this.notCheckerContract = true;
      } else if (!this.signatureContract) {
        this.setResponseError('Нужно согласиться с порядком подписания документов');
        this.notCheckedSignatureContract = true;
      } else {
        this.handleSubmit();
      }
    },
    setShowAddress(value) {
      this.$store.commit(`registration/${types.SET_ADDITIONAL_POST_ADDRESS}`, value);
    },
    setVat(value) {
      if (value === 'С НДС') {
        this.$store.commit(`registration/${types.SET_VAT}`, 1);
      } else {
        this.$store.commit(`registration/${types.SET_VAT}`, 0);
      }
    },
    setPercentage(value) {
      this.selectedPercentage = value;
    },
    onBeforeRequest() {
      this.mask();
    },

    onAfterRequest() {
      this.unmask();
    },

    handleRequestUrl() {
      return '/registration';
    },

    handleRequestParams() {
      const res = {
        country: this.country,
        language: this.language,
        phone_code: this.phoneCode,
        phone_number: this.phoneNumber,
        phone_verification: this.smsCode,
        client_type: this.clientType,
        inn: this.inn,
        vat: this.vat,
        first_name: this.firstName,
        last_name: this.lastName,
        // 'post_address': this.postAddress,
        additional_post_address: this.additionalPostAddress,
        email: this.email,
        email_verification: this.emailCode,
        password: this.password,
      };

      if (this.vat === 1) {
        res.vat_rate = Number(this.selectedPercentage.slice(0, -1));
      }

      if (this.additionalPostAddress) {
        return {
          ...res,
          ...{
            real_post_address_index: this.realPostAddressIndex,
            real_post_address_city: this.realPostAddressCity,
            real_post_address_street: this.realPostAddressStreet,
            real_post_address_house: this.realPostAddressHouse,
            real_post_address_building: this.realPostAddressBuilding,
            real_post_address_office: this.realPostAddressOffice,
          },
        };
      }

      return res;
    },

    handlePostResponce(response) {
      if (this.isSuccessfulRequest(response)) {
        this.handleResponse(response);
      }
      if (this.isFailedRequest(response)) {
        switch (this.getResponceErrorCode(response)) {
          case errorCodes.ERROR_SECURITY_CODE_IS_NOT_VALID:
          case errorCodes.ERROR_EMAIL_IS_NOT_CONFIRMED:
          case errorCodes.ERROR_EMAIL_DOES_NOT_EXIST:
            this.handleSecurityCode();
            break;
          default:
            this.handleResponseError(response);
            break;
        }
      }
    },

    handleResponse(response) {
      if (this.isSuccessfulRequest(response)) {
        switch (this.getResponceStatusCode(response)) {
          case responseCodes.RESPONSE_REGISTRATION_COMPLETED:
            this.cookie = response.data.cookie;
            this.returnUrl = response.data.redirect_url;
            this.$router.push({ name: 'redirect' });

            ym(26920401, 'reachGoal', 'registrationCompleted');
            break;
          default:
            this.setResponseError('Ошибка регистрации пользователя');
        }
      }

      if (this.isFailedRequest(response)) {
        switch (this.getResponceErrorCode(response)) {
          // Тонкий момент!
          // Email существует, но не подтвержден или Email не существует:
          // в любом случае отправляем на регу, там разберемся
          case errorCodes.ERROR_SECURITY_CODE_IS_NOT_VALID:
          case errorCodes.ERROR_EMAIL_IS_NOT_CONFIRMED:
          case errorCodes.ERROR_EMAIL_DOES_NOT_EXIST:
            this.handleSecurityCode();
            break;
          default:
            this.handleResponseError(response);
            break;
        }
      }
    },

    handleSecurityCode() {
      // Отправляем код по email
      this.$http
        .post('/email/send-security-code', {
          token_scope: 'registration',
          email: this.email,
        })
        .then((response) => {
          if (this.isSuccessfulRequest(response)) {
            switch (this.getResponceStatusCode(response)) {
              // Номер телефона подтвержден, нужно ввести пароль
              case responseCodes.RESPONSE_SECURITY_CODE_WAS_SENT:
                // Переходим на страницу ввода кода
                this.$router.push({
                  name: 'enter-email-code',
                  params: {
                    route: this.$route.name,
                  },
                });

                break;

              default:
                this.setResponseError('Ошибка генерации токена');
            }
          }

          if (this.isFailedRequest(response)) {
            this.handleResponseError(response);
          }
        })
        .catch((error) => {
          this.catchResponseError();
        })
        .finally(() => {
          this.onAfterRequest();
        });
    },

    togglePostAddressFieldRequired(response) {
      const isNotActive = response.data.error_code === 'error_company_is_not_active';
      const isNewCompany = response.data.error_code === 'error_company_is_not_registered';
      const isPostAddressEmpty = response.data.post_address_is_empty === true;

      if (isNotActive || isNewCompany || isPostAddressEmpty) {
        this.showPostAddress = true;
      }
    },

    handleInn() {
      this.showCompanyWarning = false;

      if (this.clientType === 'driver' && this.inn) {
        this.mask();

        // Проверяем номер телефона на валидность
        this.$http
          .post('/inn/check-driver-inn', {
            inn: this.inn,
          })
          .then((response) => {
            this.togglePostAddressFieldRequired(response);

            switch (this.getResponceStatusCode(response)) {
              // Номер телефона подтвержден, нужно ввести пароль
              case responseCodes.RESPONSE_COMPANY_IS_REGISTERED:
                this.showCompanyWarning = true;
                break;
            }

            switch (this.getResponceErrorCode(response)) {
              case errorCodes.ERROR_COMPANY_IS_NOT_REGISTERED:
                this.showCompanyWarning = false;
                break;
            }
          })
          .catch((error) => {
            this.catchResponseError(error);
          })
          .finally(() => {
            this.unmask();
          });
      }
    },
  },
};
</script>
